import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import online from '../../Assets/Online.png';
import students from '../../Assets/Students.png';
import live from '../../Assets/Live.png';
import './UsageStatus.css';

function UsageStatus() {
  const [courseCount, setCourseCount] = useState(0);
  const [studentCount, setStudentCount] = useState(0);
  const [teacherCount, setTeacherCount] = useState(0);

  // Target numbers
  const targetCourses = 892;
  const targetStudents = 421;
  const targetTeachers = 107;

  useEffect(() => {
    // Animation duration in seconds
    const duration = 2;
    
    const animateCount = (setter, target, duration) => {
      let start = null;
      const step = (timestamp) => {
        if (!start) start = timestamp;
        const progress = Math.min((timestamp - start) / (duration * 1000), 1);
        const value = Math.floor(progress * target);
        setter(value);
        if (progress < 1) {
          window.requestAnimationFrame(step);
        }
      };
      window.requestAnimationFrame(step);
    };

    animateCount(setCourseCount, targetCourses, duration);
    animateCount(setStudentCount, targetStudents, duration);
    animateCount(setTeacherCount, targetTeachers, duration);
  }, []);

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  };

  const numberVariants = {
    pulse: {
      scale: [1, 1.05, 1],
      transition: {
        duration: 1.5,
        repeat: Infinity,
        repeatType: "loop"
      }
    }
  };

  return (
    <div className='usage-container'>
      <motion.div 
        className='usage-online'
        initial="hidden"
        animate="visible"
        variants={itemVariants}
      >
        <img src={online} alt="online" className="online-icon" />
        <div className='title-description'>
          <span className='usage-title'>Online Course</span>
          <span className='usage-description'>
            There are over{' '}
            <motion.span 
              className='usage-status'
              variants={numberVariants}
              animate="pulse"
            >
              {courseCount.toLocaleString()}
            </motion.span>{' '}
            courses available from our experts
          </span>
        </div>
      </motion.div>

      <motion.div 
        className='usage-online'
        initial="hidden"
        animate="visible"
        variants={itemVariants}
        transition={{ delay: 0.2 }}
      >
        <img src={students} alt="students" className="online-icon" />
        <div className='title-description'>
          <span className='usage-title'>Students Careers</span>
          <span className='usage-description'>
            More than{' '}
            <motion.span 
              className='usage-status'
              variants={numberVariants}
              animate="pulse"
            >
              {studentCount.toLocaleString()}
            </motion.span>{' '}
            students are taking classes daily
          </span>
        </div>
      </motion.div>

      <motion.div 
        className='usage-online'
        initial="hidden"
        animate="visible"
        variants={itemVariants}
        transition={{ delay: 0.4 }}
      >
        <img src={live} alt="live" className="online-icon" />
        <div className='title-description'>
          <span className='usage-title'>Teacher Live Sessions</span>
          <span className='usage-description'>
            About{' '}
            <motion.span 
              className='usage-status'
              variants={numberVariants}
              animate="pulse"
            >
              {teacherCount.toLocaleString()}
            </motion.span>{' '}
            instructors are active on live sessions
          </span>
        </div>
      </motion.div>
    </div>
  );
}

export default UsageStatus;